import { useNavigate } from "react-router-dom";
import InventoryStaffAuthGate from "@/components/mobile/InventoryStaffAuthGate";
import { enterStaffPortal, applyStaffPortalDocument } from "@/lib/staffPortal";

export default function InventoryStaffJoin() {
  const navigate = useNavigate();

  const onComplete = () => {
    enterStaffPortal("inventory", window.location.origin + "/ti/hub");
    applyStaffPortalDocument("inventory");
    navigate("/ti/hub", { replace: true });
  };

  return <InventoryStaffAuthGate initialMode="signup" onComplete={onComplete} />;
}
